import React from "react";
import logo from "../../assets/images/WS-logo-for-landing-page-small.png";

const Header = () => {
  return (
    <div className="md:mb-0 flex items-center justify-center bg-platinum py-4">
      <div className="mr-6">
        <img src={logo} alt="WS Logo" className="w-full h-auto" />
      </div>
    </div>
  );
};

export default Header;